import KendoSplitterMixin from './KendoSplitterMixin'

export default {
    name: 'kendo-splitter',
    mixins: [ KendoSplitterMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoSplitter/index.js